module.exports = __webpack_public_path__ + "img/4club-01.215cd26f.svg";